define('OutSystems/ClientRuntime/modules/Database/WebSQL/WebSQLTransactionMode',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WebSQLTransactionMode;
    (function (WebSQLTransactionMode) {
        WebSQLTransactionMode[WebSQLTransactionMode["Read"] = 0] = "Read";
        WebSQLTransactionMode[WebSQLTransactionMode["Write"] = 1] = "Write";
        WebSQLTransactionMode[WebSQLTransactionMode["Upgrade"] = 2] = "Upgrade";
    })(WebSQLTransactionMode || (WebSQLTransactionMode = {}));
    exports.default = WebSQLTransactionMode;
});
//# sourceMappingURL=WebSQLTransactionMode.js.map;
